export function checkEmail(email) {
    // eslint-disable-next-line
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

import validUrl from 'valid-url'

export function isValidURL(url) {
  var encodedURI = ""
  for (var i = 0; i < url.length; i++) {
    if (url[i].charCodeAt(0) > 126 || url[i].charCodeAt(0) < 32) encodedURI += encodeURIComponent(url[i])
    else encodedURI += url[i]
  }
  if (validUrl.isUri(encodedURI)) return true
  else return false
}
